<template>
    <div class="side-class">
        <div class="side-class-title">
            <div class="side-class-btn">会员单位</div>
        </div>
        <div class="member-unit">
            <div class="single-unit">
                <div class="unit-lable">
                    <div class="lable-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconcfb-hy-dc" />
                        </svg>
                    </div>
                    <div class="lable-name">电厂机组</div>
                </div>
                <div class="unit-content">
                    <vue-seamless-scroll
                        :data="electricList"
                        class="seamless-warp"
                        :class-option="classOption"
                        v-if="electricList.length >0"
                    >
                        <ul class="item">
                            <li v-for="item1 in electricList" :key="item1.id">
                                <el-link
                                    :href="item1.redirect"
                                    target="_blank"
                                    :underline="false"
                                    :title="item1.title"
                                >{{ item1.title | ellipsis(13)}}</el-link>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
            <div class="single-unit">
                <div class="unit-lable">
                    <div class="lable-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconcfb-hy-shb" />
                        </svg>
                    </div>
                    <div class="lable-name">设备厂商</div>
                </div>
                <div class="unit-content">
                    <vue-seamless-scroll
                        :data="merchantList"
                        class="seamless-warp"
                        :class-option="merchantOption"
                        v-if="merchantList.length >0"
                    >
                        <ul class="item">
                            <li v-for="item2 in merchantList" :key="item2.id">
                                <el-link
                                    :href="item2.redirect"
                                    target="_blank"
                                    :underline="false"
                                    :title="item2.title"
                                >{{ item2.title | ellipsis(13)}}</el-link>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
            <div class="single-unit">
                <div class="unit-lable">
                    <div class="lable-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconcfb-hy-gx1" />
                        </svg>
                    </div>
                    <div class="lable-name">科研院所</div>
                </div>
                <div class="unit-content">
                    <vue-seamless-scroll
                        :data="schoolList"
                        class="seamless-warp"
                        :class-option="schoolOption"
                        v-if="schoolList.length >0"
                    >
                        <ul class="item">
                            <li v-for="item3 in schoolList" :key="item3.id">
                                <el-link
                                    :href="item3.redirect"
                                    target="_blank"
                                    :underline="false"
                                    :title="item3.title"
                                >{{ item3.title | ellipsis(13)}}</el-link>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vueSeamlessScroll from 'vue-seamless-scroll';
    // 必须引用
    export default {
        components: {
            vueSeamlessScroll
        },
        data() {
            return {
                active: 'electric',
                type: 'electric', // ['电场'⇒'['电场'⇒'electric','厂商'⇒'merchant','school'⇒'科研高校'];','厂商'⇒'merchant','school'⇒'科研高校'];
                electricList: [],
                merchantList: [],
                schoolList: []
            };
        },
        computed: {
            classOption() {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1500 // 单步运动停止的时间(默认值1000ms)
                };
            },
            merchantOption() {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1500 // 单步运动停止的时间(默认值1000ms)
                };
            },
            schoolOption() {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1500 // 单步运动停止的时间(默认值1000ms)
                };
            }
        },
        created() {
            this.getElectricList();
            this.getMerchantList();
            this.getSchoolList();
        },
        methods: {
            getElectricList() {
                this.httpGet(this.$root.getMemberUnit, {
                    type: 'electric'
                })
                    .then(result => {
                        this.electricList.push(...result.list);
                        console.log('electricList', this.electricList);
                    })
                    .catch(err => {
                        console.error('getMemberUnit-getElectricList-err', err);
                    });
            },
            getMerchantList() {
                this.httpGet(this.$root.getMemberUnit, {
                    type: 'merchant'
                })
                    .then(result => {
                        this.merchantList.push(...result.list);
                        console.log('merchantList', this.merchantList);
                    })
                    .catch(err => {
                        console.error('getMemberUnit-getMerchantList-err', err);
                    });
            },
            getSchoolList() {
                this.httpGet(this.$root.getMemberUnit, {
                    type: 'school'
                })
                    .then(result => {
                        this.schoolList.push(...result.list);
                        console.log('schoolList', this.schoolList);
                    })
                    .catch(err => {
                        console.error('getMemberUnit-schoolList-err', err);
                    });
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    >>>.el-tabs__item {
        width: 34%;
        padding: 0;
        color: gray3;
        font-weight: bold;
        font-size: 18px;
    }

    >>>.el-tabs__active-bar {
        background: white;
        height: 0;
    }

    >>>.el-tabs__item.is-active {
        color: #2C7EE5;
    }

    .side-class {
        background: #F6F6F6;

        .side-class-title {
            padding-left: 0;
        }
    }

    .member-unit {
        // padding: 10px 10px 20px 15px;
        height: 745px;
        background:#F6F6F6;
        overflow: hidden;

        .single-unit {
            height: 245px;
            padding: 0 17px;
            margin-bottom: 5px;
            background: white;

            .unit-lable {
                border-bottom: 1px solid #E8E8E8;
                height: 44px;
                flex-x(flax-start);

                .lable-icon {
                    width: 24px;
                    height: 24px;
                    background: #4093FF;
                    border-radius: 24px;
                    flex-center();

                    svg {
                        width: 14px;
                        height: 14px;
                        fill: white;
                    }
                }

                .lable-name {
                    margin-left: 8px;
                    height: 22px;
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(51, 51, 51, 1);
                    line-height: 22px;
                }
            }

            .unit-content {
                height: 200px;

                .seamless-warp {
                    width: 100%;
                    height: 200px;
                    overflow: hidden;

                    li {
                        font-size: 14px;
                        color: gray6;
                        line-height: 32px;
                        ellipsis();
                    }

                    li:hover {
                        cursor: pointer;
                        color: #1153CD;
                    }

                    >>>.el-link--inner {
                        // max-width: 197px !important;
                        // width: 100%;
                        ellipsis();
                    }

                    >>>.el-link--inner:hover {
                        cursor: pointer;
                        color: #1153CD;
                    }

                    .title {
                        ellipsis();
                    }
                }
            }
        }
    }

    li {
        font-size: 14px;
        color: gray6;
        line-height: 32px;
        ellipsis();
    }

    li:hover {
        cursor: pointer;
        color: #1153CD;
    }

    a {
        color: gray6;
    }

    .title {
        ellipsis();
    }
</style>
